module.exports = __webpack_public_path__ + "static/media/bg2.a2d39457.png";